import { render, staticRenderFns } from "./FeedbackWidget.vue?vue&type=template&id=1d13c8f3&"
import script from "./FeedbackWidget.vue?vue&type=script&lang=js&"
export * from "./FeedbackWidget.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackWidget.vue?vue&type=style&index=0&id=1d13c8f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports